import formatMessage from './../i18n/formatMessage';

export default [
  { id: 0, name: formatMessage('acompanhamentoProdutor.acre') },
  { id: 1, name: formatMessage('acompanhamentoProdutor.alqueire') },
  { id: 2, name: formatMessage('acompanhamentoProdutor.hectare') },
  { id: 3, name: formatMessage('acompanhamentoProdutor.m2') },
  { id: 4, name: formatMessage('acompanhamentoProdutor.metro') }
];
